import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { UploadFile } from 'src/core/components';

import { selectFilesData } from './selectors';
import { uploadFile as uploadFileAction, removeFileData } from './actions';

const UploadFileContainer = ({ uploadFile, files, title, description, resetData }) => {
  const isSubmitDisabled = () => {
    const incompleteFile = files.find((file) => file.isUploading);
    const errorFile = files.find((file) => file.error);

    return !files.length || !!incompleteFile || !!errorFile;
  };

  return (
    <UploadFile
      {...{
        title,
        description,
        files,
        uploadFile,
        submitDisabled: isSubmitDisabled(),
        resetData
      }}
    />
  );
};

UploadFileContainer.propTypes = {
  files: PropTypes.array,
  title: PropTypes.object.isRequired,
  description: PropTypes.object.isRequired,
  uploadFile: PropTypes.func.isRequired,
  resetData: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  files: selectFilesData(state)
});

const mapDispatchToProps = {
  uploadFile: uploadFileAction,
  resetData: removeFileData
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadFileContainer);
